const colorList = [
  '#6150FF',
  '#5994FF',
  '#4DCCFF',
  '#3EDC3C',
  '#32FFCE',
  '#FF9561',
  '#FF6868',
  '#A161FF',
  '#FE84F2',
  '#C7C7C7',
];

export default colorList;
